<template>
  <div class="animated fadeIn overflow-auto" style="max-height: 400px;">

    <b-card no-body style="margin: 5px" >
      <b-card-body fluid  title="Products">
        <b-row no-gutters>
              <p style="padding: 10px;" v-if="products.length == 0"> <b>No Products found...</b></p>
              <b-card align="centre"
                border-variant="primary"
                v-for="product in products"
                :key="product.id"
                 class="m-1"
                 style="max-width: 150px;"
                 @click="clicked(product)" tag="b-button" no-body
                >
                  <b-card-img-lazy src="https://picsum.photos/600/300/?image=25"></b-card-img-lazy>
                  <b-card-text> <b>{{product.name}}</b></b-card-text>
                </b-card>


        </b-row>

      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import Vue from 'vue'


export default {
  name: 'POSProducts',
  props: {
    products: {
      type: Array,
      default: [],
    }
  },
  components: {},
  data: function() {
    return {
    }
  },
  methods:{
    clicked(product){
      let tempProduct = Object.assign({}, product);
      this.$emit('productClicked', tempProduct);
    }
  }
};
</script>

<style>
</style>
